import Head from 'gatsby-theme-mdx-deck/src/components/head';
import customTheme from "../../../../src/style/decks-theme.js";
import koenigsbergSketch from "../../../../src/img/koenigsberg-sketch.png";
import koenigsbergCity from "../../../../src/img/koenigsberg.png";
import koenigsbergBridges from "../../../../src/img/koenigsberg-bridges.png";
import koenigsbergGraph from "../../../../src/img/koenigsberg-graph.png";
import moreno from "../../../../src/img/moreno.jpeg";
import graphMorphologies from "../../../../src/img/graph-morphologies.jpeg";
import aimeDuplicates from "../../../../src/img/aime_duplicates.png";
import aimeBalloons from "../../../../src/img/aime_balloons.png";
import * as React from 'react';
export default {
  Head,
  customTheme,
  koenigsbergSketch,
  koenigsbergCity,
  koenigsbergBridges,
  koenigsbergGraph,
  moreno,
  graphMorphologies,
  aimeDuplicates,
  aimeBalloons,
  React
};